import { formatNumber } from 'ui';

export const formatThreshold = (threshold: number) => {
  return formatNumber(threshold < 1 ? threshold * 100 : threshold, {
    maximumFractionDigits: 2,
    style: 'percent',
  });
};
